import { render, staticRenderFns } from "./LocalPlatform.vue?vue&type=template&id=fac17f3e&scoped=true"
import script from "./LocalPlatform.vue?vue&type=script&lang=js"
export * from "./LocalPlatform.vue?vue&type=script&lang=js"
import style0 from "./LocalPlatform.vue?vue&type=style&index=0&id=fac17f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac17f3e",
  null
  
)

export default component.exports